// Blog share — copy-link + centered popups dla FB/X/LinkedIn.
// Brak zewnętrznych pluginów, brak trackerów.

function initBlogShare() {
  document.querySelectorAll('[data-share-copy]').forEach((btn) => {
    btn.addEventListener('click', async () => {
      const row = btn.closest('[data-share-row]');
      const url = row?.getAttribute('data-share-url') || window.location.href;
      const original = btn.innerHTML;
      const setOk = () => {
        btn.innerHTML =
          '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" aria-hidden="true"><path d="M4 12.5 9.5 18 20 6.5"/></svg>';
        btn.classList.add('bg-black', 'text-white');
        setTimeout(() => {
          btn.innerHTML = original;
          btn.classList.remove('bg-black', 'text-white');
        }, 1800);
      };
      try {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(url);
          setOk();
          return;
        }
        // Fallback dla starych przeglądarek / http context
        const ta = document.createElement('textarea');
        ta.value = url;
        ta.style.position = 'fixed';
        ta.style.opacity = '0';
        document.body.appendChild(ta);
        ta.select();
        document.execCommand('copy');
        document.body.removeChild(ta);
        setOk();
      } catch (e) {
        window.prompt('Skopiuj link:', url);
      }
    });
  });

  // External share popups (FB/X/LinkedIn) — wycentrowane okno.
  document.querySelectorAll('[data-share-row] a[target="_blank"]').forEach((a) => {
    a.addEventListener('click', (e) => {
      if (e.metaKey || e.ctrlKey || e.shiftKey) return; // user wants new tab
      e.preventDefault();
      const w = 600;
      const h = 600;
      const left = (window.screen.width || 1200) / 2 - w / 2;
      const top = (window.screen.height || 800) / 2 - h / 2;
      window.open(
        a.href,
        'kbShare',
        `width=${w},height=${h},top=${top},left=${left},toolbar=0,menubar=0,location=0`
      );
    });
  });
}

if (document.readyState !== 'loading') initBlogShare();
else document.addEventListener('DOMContentLoaded', initBlogShare);
